import { render, staticRenderFns } from "./content-tabs.vue?vue&type=template&id=633c054a"
import script from "./content-tabs.vue?vue&type=script&lang=js"
export * from "./content-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633c054a')) {
      api.createRecord('633c054a', component.options)
    } else {
      api.reload('633c054a', component.options)
    }
    module.hot.accept("./content-tabs.vue?vue&type=template&id=633c054a", function () {
      api.rerender('633c054a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/content-tabs.vue"
export default component.exports